export default "__VITE_ASSET__DVyx_NVl__"